module.exports = __webpack_public_path__ + "media/images/medal-purple-2ee597be90f40e9b856950b425477725.svg";